import React, { memo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import PropTypes from "prop-types";
import { Tooltip } from "../../tooltip/tooltip";

const AttributeControls = memo(
    ({
        containsUuid,
        completed,
        readOnly,
        required,
        onAddAttribute,
        onRemoveAttribute,
        tooltip,
        isReadOnlyAdd,
        isReadOnlyDelete,
        readonlyOnTaskType,
        isBrandVerified,
        isQa,
    }) => {
        const enableBVCQADisableBV = isBrandVerified && isQa ? true : isBrandVerified ? false : true;
        const showRemoveIcon = containsUuid && !completed && !required && !readOnly && !readonlyOnTaskType && enableBVCQADisableBV;
        const showAddIcon = !containsUuid && !completed && !readonlyOnTaskType && enableBVCQADisableBV;

        return (
            <div className="align-items-center">
                {tooltip && (
                    <Tooltip
                        text={tooltip}
                        classes="m-r-4"
                    >
                        <div className="icon -small">
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </div>
                    </Tooltip>
                )}
                {showAddIcon && (
                    <div
                        data-testid="add-attribute-button"
                        className={classnames("button -small", { "-disabled": isReadOnlyAdd })}
                        onClick={isReadOnlyAdd ? null : onAddAttribute}
                    >
                        <FontAwesomeIcon icon={faPlus} />
                    </div>
                )}
                {showRemoveIcon && (
                    <div
                        data-testid="remove-attribute-button"
                        className={classnames("button -small", { "-disabled": isReadOnlyDelete })}
                        onClick={isReadOnlyDelete ? null : onRemoveAttribute}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </div>
                )}
            </div>
        );
    }
);

AttributeControls.propTypes = {
    containsUuid: PropTypes.bool.isRequired,
    completed: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool.isRequired,
    required: PropTypes.bool.isRequired,
    onAddAttribute: PropTypes.func.isRequired,
    onRemoveAttribute: PropTypes.func.isRequired,
};

export default AttributeControls;
